import React, {useState} from 'react'
import './color.css'

export const ColorField = (props) => {

    const {id, label="Color", value, onChange} = props

    function change(event) {
        const color = event.target.value
       if (onChange) onChange(id, color)
    }

    return (
        <div className="color-field">
            <label htmlFor={id}>{label}</label>
            <input id={id} type="color" onChange={change} value={value}/>
        </div>
    )
}